/**
 * Cylindo 3D Viewer Component
 * Renders the Cylindo 3D viewer with built-in AR support
 *
 * Note: The viewer includes AR functionality via the 'ar' control.
 * Users can click the AR button in the viewer to access the AR experience.
 * The QR code is not displayed here as the viewer handles AR natively.
 */

import React from 'react';
import PropTypes from 'prop-types';

const CylindoViewer = ({
  customerId,
  code,
  configuration,
  controls = 'ar fullscreen zoom',
}) => {
  return (
    <cylindo-viewer
      code={code}
      configuration={configuration}
      controls={controls}
      customer-id={customerId}
      style={{aspectRatio: 256 / 123}}
    />
  );
};

CylindoViewer.propTypes = {
  code: PropTypes.string.isRequired,
  configuration: PropTypes.string,
  controls: PropTypes.string,
  customerId: PropTypes.string.isRequired,
};

export default CylindoViewer;
